import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import { Backdrop, useTheme } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import CircularProgress from "@mui/material/CircularProgress";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { authenticationService } from "./services/authentication.service";
import version from "./version.json";

const useAxiosLoader = () => {
  const [authFlag, setAuthFlag] = useState(false);
  const [errorRes, setErrorRes] = useState({});
  let currentRequestUrl = "";
  const urls = [
    // "/price/copaynew/",
    "/price/cashnew/",
    // "/price/couponnew/",
    "/price/retail/",
    "/zipcode/validate/",
  ];
  const urlsExcluded = ["/authenticate"];

  const handleRequest = async (config) => {
    let configObj = { ...config };
    const urls = ["/authenticate", "/organization/", "/register"];
    currentRequestUrl = config.url;
    console.log("config", config);
    console.log("currentRequestUrl", currentRequestUrl);
    if (urls.indexOf(config.url) === -1) {
      const appData = JSON.parse(sessionStorage.getItem("applicationData"));

      const storedRefreshToken = JSON.parse(
        sessionStorage.getItem("refreshToken")
      );
      const now = new Date().getTime();
      const jwtToken = JSON.parse(sessionStorage.getItem("jwtToken"));
      if (
        storedRefreshToken &&
        (!jwtToken || !appData?.expiresIn || appData?.expiresIn - now <= 0)
      ) {
        console.log("setAuthFlag 1 true");
        setAuthFlag(true);
        const authData = await authenticationService.authenticateDevice(
          storedRefreshToken
        );
        configObj.headers.Authorization = "Bearer " + authData.data.jwtToken;
        console.log("setAuthFlag 2 false");
        setAuthFlag(false);
      } else if (!storedRefreshToken) {
        try {
          console.log("setAuthFlag 3 true");
          setAuthFlag(true);
          const orgcode =
            localStorage.getItem("orgCode") ||
            window.location.href.split("//")[1].split(".")[0];
          let storedDeviceID = localStorage.getItem("deviceId");
          if (storedDeviceID == null) {
            storedDeviceID = uuidv4();
            //localStorage.setItem("deviceId", storedDeviceID);
          }
          let browserInfo = navigator.userAgent;
          let browserType = "WEB";
          let appCode = localStorage.getItem("appCode");
          const registerData = await authenticationService.registerDevice(
            storedDeviceID,
            browserType,
            browserInfo,
            appCode,
            orgcode
          );
          if (registerData.data) {
            const authData = await authenticationService.authenticateDevice(
              registerData.data
            );
            configObj.headers.Authorization =
              "Bearer " + authData.data.jwtToken;
            console.log("setAuthFlag 4 false");
            setAuthFlag(false);
          } else {
            window.location.reload();
          }
        } catch (e) {
          console.log("setAuthFlag 5 false");
          setAuthFlag(false);
        }
      }
    }
    return configObj;
  };

  const handleReqError = (error) => {
    console.log("handleError", error);
    return Promise.reject(error);
  };

  const handleResponse = async (response) => {
    setErrorRes({});

    if (response?.data?.success) {
      return response;
    }

    let output = { ...response?.data };

    if (!output?.message || output?.message === "") {
      output = {
        ...output,
        message: "Some error occured!. Please try again",
      };
    }

    const matchedUrl = urls.filter((item) =>
      response?.config?.url?.includes(item)
    );

    if (matchedUrl.length) {
      throw output;
    }

    setErrorRes(output);
    throw output;
  };

  const handleResError = async (error) => {
    if (error?.response?.status === 401) {
      // sessionStorage.removeItem("refreshToken");
      sessionStorage.removeItem("jwtToken");
      sessionStorage.removeItem("isLoggedIn");
    }
    let output = { ...error.response };
    if (
      output &&
      (!output.data ||
        !output?.data?.message ||
        output?.data?.message === "" ||
        output.data === "")
    ) {
      output.data = {
        success: false,
        message: "Some error occured!. Please try again",
      };
    }

    const matchedUrl = urlsExcluded.filter(
      (item) => item === currentRequestUrl
    );

    if (matchedUrl.length) {
      return Promise.reject(output?.data);
    }

    setErrorRes(output?.data);
    return Promise.reject(output?.data);
  };

  useEffect(() => {
    // add request & response interceptors
    axios.interceptors.request.use(handleRequest, handleReqError);
    axios.interceptors.response.use(handleResponse, handleResError);
  }, []);

  return { loading: authFlag, errorResponse: errorRes };
};

const AppWithGlobalLoader = () => {
  const { loading, errorResponse = {} } = useAxiosLoader();
  const theme = useTheme();

  const destroySession = () => {
    // let message = " ";

    // sessionStorage.removeItem("refreshToken");
    sessionStorage.removeItem("applicationData");
    sessionStorage.removeItem("jwtToken");
    sessionStorage.removeItem("deviceInfo");

    // e.returnValue = message;

    // return message;
  };
  
  useEffect(() => {
    if (window?.performance?.navigation?.type == 1) {
      destroySession();
    }
  }, [window?.performance]);

  useEffect(() => {
    // window.addEventListener("beforeunload", destroySession);
    const buildVersion = localStorage.getItem("build_version");

    if (!buildVersion) {
      localStorage.setItem("build_version", version?.commit);
    } else if (buildVersion !== version?.commit) {
      localStorage.setItem("build_version", version?.commit);
      window.location.reload(true);
    }

    return () => {
      destroySession();
    };
  }, []);

  return (
    <>
      {loading ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress
            style={{ color: theme?.palette?.secondary?.main }}
          />
        </Backdrop>
      ) : null}
      <App axiosErrorResponse={errorResponse} />
    </>
  );
};

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(<AppWithGlobalLoader />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
